import React from 'react';
import { useStore } from 'effector-react';
import { LibApiType } from '@types';
import { queryKeys } from '@queryClient';
import MultiplePageFetchList from '../components/MultiplePageFetchList';
import { $libSearch } from '../stores/libState';
import MultiplePageSearchList from '../components/MultiplePageSearchList';
import RowDoc from './RowDoc';
import {
  useLibFetchListProps,
  useLibSearchListProps,
} from '../utils/useLibListProps';

function ListDoc() {
  const query = useStore($libSearch);
  const searchUrls = useLibSearchListProps();
  const fetchUrls = useLibFetchListProps('docs');
  return query ? (
    <MultiplePageSearchList
      queryKey={queryKeys.libListDoc}
      {...searchUrls}
      libApiType={LibApiType.doc}
      row={RowDoc}
    />
  ) : (
    <MultiplePageFetchList
      queryKey={queryKeys.libListDoc}
      {...fetchUrls}
      row={RowDoc}
    />
  );
}

export default ListDoc;
